import { Mail, Clock, MapPin, Phone } from "lucide-react";
import { Reveal, MaskLine, SectionLabel } from "@/components/Reveal";
import EmployerForm from "@/components/EmployerForm";

export default function Contact() {
  return (
    <>
      <section className="pt-[116px] pb-10 lg:pt-[140px] lg:pb-12" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <MaskLine delay={0.05}>
            <span className="flex items-center gap-4">
              <span className="h-px w-12 bg-brand-red" />
              <span className="font-mono text-[11px] uppercase tracking-[0.38em] text-brand-red font-medium">Contact</span>
            </span>
          </MaskLine>
          <h1 className="mt-6 font-display font-extrabold tracking-tight text-slate-900 text-4xl sm:text-6xl lg:text-7xl leading-[1.04] max-w-4xl">
            <MaskLine delay={0.18}>Let's start the</MaskLine>
            <MaskLine delay={0.3}><span className="text-brand-red">conversation.</span></MaskLine>
          </h1>
          <MaskLine delay={0.44} className="mt-6 max-w-2xl">
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
              Hiring, staffing, or exploring your next role — tell us what you need and we'll respond promptly.
            </p>
          </MaskLine>
        </div>
      </section>

      <section className="pb-16 lg:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="lg:sticky lg:top-28">
                <SectionLabel>Reach Us</SectionLabel>
                <div className="bg-white border border-slate-200 rounded-[1.75rem] px-7 sm:px-8 divide-y divide-slate-100 shadow-[0_30px_70px_-40px_rgba(14,15,19,0.25)]">
                  <div className="flex items-start gap-4 py-6">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light text-brand-red shrink-0"><MapPin size={18} /></span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400">Office Address</p>
                      <p className="mt-1.5 text-sm font-medium text-slate-900 leading-relaxed" data-testid="contact-address">
                        2nd Floor, Room No. 4E, 7, Lyons Range,<br />
                        Murgighata, Dalhousie, Kolkata,<br />
                        West Bengal – 700001, India
                      </p>
                    </div>
                  </div>
                  <a href="tel:+919831658642" className="group -mx-3 flex items-start gap-4 rounded-xl px-3 py-6 transition-colors duration-300 hover:bg-brand-light/50" data-testid="contact-phone-block">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light text-brand-red shrink-0 transition-colors duration-300 group-hover:bg-white"><Phone size={18} /></span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400">Phone</p>
                      <span className="mt-1.5 block text-sm font-medium text-slate-900 group-hover:text-brand-red transition-colors" data-testid="contact-phone">+91 98316 58642</span>
                    </div>
                  </a>
                  <a href="mailto:info@genspireconsulting.com" className="group -mx-3 flex items-start gap-4 rounded-xl px-3 py-6 transition-colors duration-300 hover:bg-brand-light/50" data-testid="contact-email-block">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light text-brand-red shrink-0 transition-colors duration-300 group-hover:bg-white"><Mail size={18} /></span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400">Email</p>
                      <span className="mt-1.5 block text-sm font-medium text-slate-900 group-hover:text-brand-red transition-colors" data-testid="contact-email">info@genspireconsulting.com</span>
                    </div>
                  </a>
                  <div className="flex items-start gap-4 py-6">
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-light text-brand-red shrink-0"><Clock size={18} /></span>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-400">Business Hours</p>
                      <div className="mt-1.5 space-y-1 text-sm font-medium text-slate-900" data-testid="contact-hours">
                        <p>Monday–Friday: 9:00 AM–6:00 PM</p>
                        <p>Saturday: 10:00 AM–4:00 PM</p>
                        <p className="text-slate-500">Sunday: Closed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.12}>
              <SectionLabel>Send an Enquiry</SectionLabel>
              <div className="bg-white border border-slate-200 rounded-[1.75rem] p-7 sm:p-9 shadow-[0_30px_70px_-40px_rgba(14,15,19,0.25)]">
                <EmployerForm defaultRequirement="General Enquiry" testId="contact-form" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
